<header class="flex-none">
  <app-header class="flex justify-between items-center border-b-1 border-surface-300 dark:border-surface-700" [authenticated]="authenticated()"></app-header>
</header>
<div class="flex flex-1 min-h-0">
  @if (authenticated()) {
    <app-left-sidebar class="overflow-y-auto shrink-0 border-r border-surface-300 dark:border-surface-700"></app-left-sidebar>
  }
  @if (authenticated()) {
    <main class="w-full relative">
      <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
        @if (!isIframe) {
          <p-panel #content class="content" [ngClass]="{'hidden': showHelp()}" styleClass="bg-surface-100 dark:bg-surface-900 h-full border-0 rounded-none main-content-panel">
            <ng-template #header>
              <h1 class="page-title text-lg text-surface-500 px-2">{{pageTitle()}}</h1>
            </ng-template>
            <div class="h-full overflow-y-auto flex flex-col px-2">
              <router-outlet></router-outlet>
              <p-toast position="top-right" key="center"/>
            </div>
          </p-panel>
        }
        <p-toast position="top-right" key="main"/>
        @if (showHelp()) {
          <app-help-overlay class="absolute left-0 top-0 right-0 bottom-0"></app-help-overlay>
        }
        <app-update></app-update>
      </main>
  } @else {
      @if (isLogoutPage) {
        <div class="flex justify-center w-full py-4">
          <router-outlet></router-outlet>
        </div>
      } @else {
        <div class="flex items-center justify-center w-full h-full py-8">
          <div class="three-dots-loader">
            <div></div><div></div><div></div><div></div>
          </div>
        </div>
      }
  }

</div>
<footer class="flex-none border-t-1 border-surface-300 dark:border-surface-700 dark:bg-surface-950">
  <app-footer class="m-2 text-center block"></app-footer>
</footer>
